exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailInput__email___1mxaH {\n  font-size: 16px;\n  color: #3f3f3f;\n  padding: 15px;\n  line-height: 16px;\n  background-color: #f7f7f7;\n  border: solid 1px #dfdfdf; }\n  .emailInput__email___1mxaH::placeholder {\n    color: #828282; }\n", ""]);

// exports
exports.locals = {
	"email": "emailInput__email___1mxaH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/EmailInput/emailInput.scss
// module id = 4518
// module chunks = 6